"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountBalance = exports.buildUnsignedTransaction = exports.broadcastTransaction = void 0;
const hedera = __importStar(require("@hashgraph/sdk"));
const sdk_1 = require("@hashgraph/sdk");
const errors_1 = require("../errors");
function broadcastTransaction(transaction) {
    return transaction.execute(getClient());
}
exports.broadcastTransaction = broadcastTransaction;
function buildUnsignedTransaction({ account, transaction, }) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const hbarAmount = hedera.Hbar.fromTinybars(transaction.amount);
        const accountId = account.freshAddress;
        return new hedera.TransferTransaction()
            .setNodeAccountIds([new sdk_1.AccountId(3)])
            .setTransactionId(hedera.TransactionId.generate(accountId))
            .setTransactionMemo((_a = transaction.memo) !== null && _a !== void 0 ? _a : "")
            .addHbarTransfer(accountId, hbarAmount.negated())
            .addHbarTransfer(transaction.recipient, hbarAmount)
            .freeze();
    });
}
exports.buildUnsignedTransaction = buildUnsignedTransaction;
function getAccountBalance(address) {
    return __awaiter(this, void 0, void 0, function* () {
        const accountId = sdk_1.AccountId.fromString(address);
        let accountBalance;
        try {
            accountBalance = yield new hedera.AccountBalanceQuery({
                accountId,
            }).execute(getBalanceClient());
        }
        catch (_a) {
            throw new errors_1.HederaAddAccountError();
        }
        return {
            balance: accountBalance.hbars.to(hedera.HbarUnit.Tinybar),
        };
    });
}
exports.getAccountBalance = getAccountBalance;
let _hederaClient = null;
let _hederaBalanceClient = null;
function getClient() {
    _hederaClient !== null && _hederaClient !== void 0 ? _hederaClient : (_hederaClient = hedera.Client.forMainnet().setMaxNodesPerTransaction(1));
    //_hederaClient.setNetwork({ mainnet: "https://hedera.coin.ledger.com" });
    return _hederaClient;
}
function getBalanceClient() {
    _hederaBalanceClient !== null && _hederaBalanceClient !== void 0 ? _hederaBalanceClient : (_hederaBalanceClient = hedera.Client.forMainnet());
    return _hederaBalanceClient;
}
//# sourceMappingURL=network.js.map